import React, { useState } from 'react';
import {
  Button,
  Card,
  Container,
  Row,
  Col,
  CardText,
} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbtack, faExternalLink } from '@fortawesome/free-solid-svg-icons';

import image2 from 'assets/img/news/GEAdditive_MagLev_PAS2023_7072.png';
import image3 from 'assets/img/news/GEAdditive_Cover.png'
import image4 from 'assets/img/news/aviation-week.svg'
import image5 from 'assets/img/news/evtol-news.png'
import image6 from 'assets/img/news/flying.png'
import image7 from 'assets/img/news/paris-air-show-54th.png'
import image8 from 'assets/img/news/transcend.jpg'
import image9 from 'assets/img/news/aerospace_america_logo_blue_720_Square.PNG'
import image10 from 'assets/img/news/aiaa.jpg'
import image11 from 'assets/img/news/xti-press.jpg'
import image12 from 'assets/img/news/DARPA-MagLev-Aero.jpg'

const useShowMore = (initialCount, totalCount) => {
  const [count, setCount] = useState(initialCount);

  const showMore = () => {
    setCount(totalCount);
  };

  const showLess = () => {
    setCount(initialCount);
    // Scroll back to the top of the "In the News" section
    const newsSection = document.getElementById('in-the-news-section');
    window.scrollTo({
      top: newsSection.offsetTop,
      behavior: 'smooth',
    });
  };

  return { count, showMore, showLess };
}

const News = () => {
  const newsArticles = [
    {
      title: "MagLev Aero Secures Dual DARPA Contracts to Advance Next-Generation U.S. Drone Propulsion",
      description: "MagLev Aero Secures Dual DARPA Contracts to Advance Next-Generation U.S. Drone Propulsion",
      date: 'September 25, 2026',
      link: 'https://www.prnewswire.com/news-releases/maglev-aero-secures-dual-darpa-contracts-to-advance-next-generation-us-drone-propulsion-302890673.html',
      imageSrc: image12,
      pinned: true,
    },
    {
      title: "MagLev Aero Select GE Additive's Addworks For Breakthrough Propulsion Platform For Ultra-Quiet eVTOLS",
      description: "An aerospace innovator with more than 20 issued patents underpinning a breakthrough propulsion platform that will enable the next generation of ultraquiet electric vertical takeoff and landing (eVTOL) aircraft – is announcing it has selected GE Additive's AddWorks™ consultancy team to support the development of additive technologies and materials for its proprietary MagLev HyperDrive™ aero propulsion platform.",
      date: 'June 20, 2023',
      link: 'https://www.prnewswire.com/news-releases/maglev-aero-selects-ge-additives-addworks-for-breakthrough-propulsion-platform-for-ultra-quiet-evtols-301855121.html',
      imageSrc: image2,
      pinned: false,
    },
    {
      title: 'Webinar: How MagLev Aero is Using Additive Manufacturing to Propel Their Next-Generation Lean, Green Flying Machine',
      description: 'This webinar explores magnetic levitation technology, how MagLev is looking to apply it to air travel, and how additive manufacturing will play an important role in enabling magnetic levitation propulsion to advance urban air mobility.',
      date: 'August 23, 2023',
      link: 'https://www.ge.com/additive/press-releases/webinar-maglev-aero-using-additive-manufacturing-eVTOL',
      imageSrc: image3,
      pinned: false,
    },
    {
        title: 'Startup Applies Maglev Technology To Ultraquiet eVTOL Propulsion',
        description: 'U.S. startup MagLev Aero has emerged from stealth mode with plans to develop a radically different propulsion system for electric vertical-takeoff-and-landing aircraft. Leveraging the magnetic levitation principle used in trains, the system promises high efficiency with low noise and increased safety, the company says.',
        date: 'May 31, 2023',
        link: 'https://aviationweek.com/aerospace/emerging-technologies/startup-applies-maglev-technology-ultraquiet-evtol-propulsion',
        imageSrc: image4,
        pinned: true, // This article is pinned
    },
    {
      title: 'Maglev Aero (HyperDrive Propulsion System)',
      description: "Maglev Aero's HyperDrive system consists of a many bladed annular rotors suspended, guided and rim-driven by a circular maglev system used for the propulsion of eVTOL passenger and cargo aircraft. The multiple thin swept blades are shaped to increase efficiency and reduce noise compared with conventional helicopter rotorblades. The HyperDrive can be fixed or tiltable with single or coaxial rim-driven rotors.",
      date: 'May 31, 2023',
      link: 'https://evtol.news/maglev-aero-hyperdrive-propulsion-system',
      imageSrc: image5,
      pinned: false,
    },
    {
        title: 'Maglev Aero Debuts Magnetic Propulsion Technology in Paris, Partners with GE',
        description: "This week at the Paris Air Show, MagLev Aero co-founders and father-and-son duo Rod and Ian Randall debuted their state-of-the-art propulsion system for electric vertical takeoff and landing (eVTOL) aircraft using an unlikely energy source: magnets.",
        date: 'June 21, 2023',
        link: 'https://www.flyingmag.com/maglev-aero-debuts-magnetic-propulsion-technology-in-paris-partners-with-ge/',
        imageSrc: image6,
        pinned: false,
      },
      {
        title: 'Video: Ultra Quiet Skies: Breakthrough Propulsion Approach To Unlock Urban Air Mobility For the Masses',
        description: "Hear from the co-founders of emerging eVTOL leader MagLev Aero on the challenges and opportunities of eVTOL acoustic management and the next breakthrough in propulsion: a platform that operates at significantly higher efficiency with lower tip speeds and blade loading to reduce noise levels in hover vs. helicopters and multi-rotor eVTOLs.",
        date: 'July 14, 2023',
        link: 'https://www.youtube.com/watch?v=nJX2jFLqx24&t=79s',
        imageSrc: image7,
        pinned: false,
      },
    // Add more news articles as needed
    {
      title: 'Transcend Eyes MagLev Propulsion For Tiltwing VTOL',
      description: "",
      date: 'March 4, 2024',
      link: 'https://aviationweek.com/aerospace/advanced-air-mobility/transcend-eyes-maglev-propulsion-tiltwing-vtol',
      imageSrc: image8,
      pinned: true,
    },
    {
      title: 'Magnetic Levitation Rises to the Occasion',
      description: "",
      date: 'October 21, 2025',
      link: 'https://aerospaceamerica.aiaa.org/institute/magnetic-levitation-rises-to-the-occasion/',
      imageSrc: image9,
      pinned: true,
    },
    {
      title: 'Powered-Lift Specialist XTI Explores Uncrewed, Magnetically Powered Aircraft',
      description: "",
      date: 'July 3, 2025',
      link: 'https://www.flyingmag.com/powered-lift-specialist-xti-explores-uncrewed-magnetically-powered-aircraft/',
      imageSrc: image11,
      pinned: false,
    },
    {
      title: 'MagLev Aero team has been awarded the 2024 AIAA V/STOL Best Paper for our technical publication: Thrust Testing and Experimental Validation of a Magnetically Levitated Rotor for Electric Flight Applications',
      description: "",
      date: 'July 27, 2024',
      link: 'https://arc.aiaa.org/doi/10.2514/6.2024-4314',
      imageSrc: image10,
      pinned: false,
    },
  ];

  // Sort the newsArticles so that pinned articles come first, then by date in descending order
  newsArticles.sort((a, b) => {
    if (a.pinned && !b.pinned) {
      return -1; // a comes first
    } else if (!a.pinned && b.pinned) {
      return 1; // b comes first
    } else {
      return new Date(b.date) - new Date(a.date) ; // sort by date in descending order
    }
  });

  const { count, showMore, showLess } = useShowMore(4, newsArticles.length);

  return (
    <div className="section section-maglev-blue-dark text-center" id="in-the-news-section">
      <Container>
        <h1 className="title" style={{ color: 'white', padding:'20px', fontWeight: 'bolder' }}>In the News</h1>
        <Row className="justify-content-center">
          {newsArticles.slice(0, count).map((article, index) => (
            <Col key={index} xs={12} sm={6} md={3} lg={3} className="mb-4" style={{ flex: '0 0 100%' }}>
              <Card style={{ height: '100%', display: 'flex', flexDirection: 'column', margin: "0px" }}>
                { /* Image */ }
                <a href={article.link} target="_blank" rel="noopener noreferrer">
                  <div style={{ flex: '0', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img src={article.imageSrc} alt={article.title} style={{
                        borderTopLeftRadius: '10px',
                        borderTopRightRadius: '10px',
                        width: '100%',
                      }} />
                  </div>
                </a>
                { /* Date */ }
                <CardText className="news-date text-left" style={{ fontSize: '1.25em', color: 'blue', paddingLeft: '10px', paddingBottom: 0, marginBottom: 0 }}>
                  <br />
                  {article.date} 
                  {article.pinned && (
                    <span className="pinned-icon" style={{paddingLeft:'10px'}}>
                      <FontAwesomeIcon icon={faThumbtack} />
                    </span>
                  )}
                </CardText>
                { /* Title */ }
                <CardText className="news-description text-left" style={{ fontSize: '1.25em', padding: '10px', color: "black", fontWeight: "normal" }}>
                  {article.title}
                </CardText>
                { /* Button */ }
                <div className="text-left mt-auto" style={{ paddingLeft: '10px', paddingBottom: '20px' }}>
                  <Button
                    href={article.link}
                    className="btn-round mr-1"
                    color="primary"
                    outline
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Content&nbsp;&nbsp;<FontAwesomeIcon icon={faExternalLink}/>
                  </Button>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
        {(count < newsArticles.length) && (
          <div className="text-center mt-4">
            <Button color="primary" size="md" onClick={showMore}>
              Show More
            </Button>
          </div>
        )}
        {(count > 4) && (
          <div className="text-center mt-4">
            <Button color="secondary" size="md" onClick={showLess}>
              Show Less
            </Button>
          </div>
        )}
      </Container>
    </div>
  );
};

export default News;
